var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricketBat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5403 2.25045C20.8742 1.91652 21.4156 1.91652 21.7495 2.25045C22.0835 2.58439 22.0835 3.12581 21.7495 3.45974L16.8527 8.35664C16.838 8.96613 17.0136 9.53029 17.2557 9.99604C17.5461 10.5547 17.5592 11.278 17.1139 11.7232L7.398 21.4392C6.92034 21.9168 6.22608 22.1461 5.59691 21.9002C3.99567 21.2744 2.7256 20.0043 2.09978 18.4031C1.85388 17.7739 2.08318 17.0797 2.56084 16.602L12.2768 6.88606C12.722 6.44081 13.4453 6.45388 14.004 6.7443C14.4697 6.98642 15.0339 7.16205 15.6434 7.14735L20.5403 2.25045Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricketBat);
export default __webpack_public_path__ + "static/media/cricket-bat.af5472523ad902a0ece3135691db7b50.svg";
export { ForwardRef as ReactComponent };